import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const Summarize = (props: SvgIconProps) => (
    <SvgIcon {...props} height="24px" viewBox="0 -960 960 960" width="24px">
        <g>
            <rect fill="none" />
        </g>

        <path d="M320-600q17 0 28.5-11.5T360-640q0-17-11.5-28.5T320-680q-17 0-28.5 11.5T280-640q0 17 11.5 28.5T320-600Zm0 160q17 0 28.5-11.5T360-480q0-17-11.5-28.5T320-520q-17 0-28.5 11.5T280-480q0 17 11.5 28.5T320-440Zm0 160q17 0 28.5-11.5T360-320q0-17-11.5-28.5T320-360q-17 0-28.5 11.5T280-320q0 17 11.5 28.5T320-280ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h440l200 200v440q0 33-23.5 56.5T760-120H200Zm0-80h560v-400H600v-160H200v560Zm0-560v160-160 560-560Z" />
    </SvgIcon>
);

export default Summarize;
